export default __webpack_public_path__ + "static/media/img-0394-serbia-full-face.74c48287.png";